module.exports = __webpack_public_path__ + "static/img/Bachelor_010569.86a7156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010569.jpg
// module id = 190
// module chunks = 0